export default __webpack_public_path__ + "0dceb1966abfc80f1bbc6b2ff4ec4875.png";